// extracted by mini-css-extract-plugin
export default {"wrapper":"ZN-z","ratingContainer":"_N-z","ratingValue":"aO-z","starSprite":"bO-z","ratingLabel":"cO-z","error":"dO-z","errorBox":"eO-z"};